var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cenNav"},[_c('div',{staticClass:"cenNavBox"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"cenNavBoxFor",class:_vm.current==index?'xz':'wxz',on:{"click":function($event){return _vm.goScroll(item,index)}}},[_vm._v("\n\t\t\t"+_vm._s(item.name)+"\n\t\t")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }